export default __webpack_public_path__ + "static/media/IMG-20170118-WA0002.92d624e5.jpg";